import { $, $$, on } from './util.js';

/* 11. FORMS MODULE — background submit
   A rewrite of theme3corednacom's src/app/js/ajax-form.js, which is jQuery
   ($.ajax + $form.serialize()). There is no jQuery on this site, so this is
   XMLHttpRequest plus a hand-rolled serialiser.

   Enhancement only: templates/forms/hub-simple-form.html posts natively
   without any of this. We leave the native post alone when there is no
   data-submit-url, and when the form is multipart — an upload cannot travel
   in a urlencoded body. */
function serializeForm(form) {
	var pairs = [];
	var els = form.elements;
	for (var i = 0; i < els.length; i++) {
		var el = els[i];
		var type = (el.type || '').toLowerCase();
		if (!el.name || el.disabled) { continue; }
		if (type === 'file' || type === 'submit' || type === 'button' || type === 'reset') { continue; }
		if ((type === 'checkbox' || type === 'radio') && !el.checked) { continue; }
		if (el.tagName === 'SELECT' && el.multiple) {
			for (var j = 0; j < el.options.length; j++) {
				if (el.options[j].selected) {
					pairs.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.options[j].value));
				}
			}
			continue;
		}
		pairs.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
	}
	return pairs.join('&');
}

export function initHubForms() {
	$$('.hub-form-el').forEach(function (form) {
		var url = form.getAttribute('data-submit-url');
		if (!url) { return; }
		if ((form.getAttribute('enctype') || '').indexOf('multipart') === 0) { return; }

		var status = $('.hub-form-status', form);
		var btn = $('.hub-form-submit', form);

		function say(msg, kind) {
			if (!status) { return; }
			status.textContent = msg;
			status.className = 'hub-form-status' + (kind ? ' is-' + kind : '');
			status.hidden = false;
		}
		function done() {
			form.classList.remove('is-busy');
			if (btn) { btn.disabled = false; }
		}

		on(form, 'submit', function (e) {
			e.preventDefault();
			if (form.classList.contains('is-busy')) { return; }
			form.classList.add('is-busy');
			if (btn) { btn.disabled = true; }
			say('Sending…');

			var xhr = new XMLHttpRequest();
			xhr.open(form.getAttribute('method') || 'POST', url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			xhr.onload = function () {
				done();
				if (xhr.status >= 200 && xhr.status < 300) {
					say('Thanks — your response has been recorded.', 'ok');
					form.reset();
				} else {
					say('That did not send (error ' + xhr.status + '). Please try again.', 'error');
				}
			};
			xhr.onerror = function () {
				done();
				say('Could not reach the server. Please try again.', 'error');
			};
			xhr.send(serializeForm(form));
		});
	});
}
